import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button, Form, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Trash2, Plus, Minus, ShoppingBag } from 'lucide-react';
import { collection, getDocs, updateDoc, doc, deleteDoc } from "firebase/firestore";
import { db } from "../firebase";

const Cart = () => {
  const [cartData, setCartData] = useState([]);

  useEffect(() => {
    fetchCartData();
  }, []);

  const fetchCartData = async () => {
    const userId = localStorage.getItem('userId');

    if (userId) {
      const querySnapshot = await getDocs(collection(db, userId));

      const list = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setCartData(list)
      console.log(list)

    }
  };

  const updateQuantity = async (item, change) => {
    const userId = localStorage.getItem('userId');
    const cartDoc = doc(db, userId, item.id);

    if (item?.quantity == 1 && change == "minus") {
      try {
        deleteDoc(doc(db, userId, item?.id));
        fetchCartData();
      } catch (error) {

      }
    }

    try {
      await updateDoc(cartDoc, {
        quantity: change == "minus" ? item.quantity - 1 : item.quantity + 1
      });

      fetchCartData();
    } catch (error) {

    }

  };

  const removeItem = (id) => {
  };

  const subtotal = cartData.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  const shipping = 10.00;
  const tax = subtotal * 0.08;
  const total = subtotal + shipping + tax;

  if (cartData.length === 0) {
    return (
      <div className="py-5">
        <Container>
          <div className="text-center py-5">
            <ShoppingBag size={80} className="text-muted mb-4" />
            <h2 className="fw-bold mb-3">Your Cart is Empty</h2>
            <p className="text-muted mb-4">Looks like you haven't added any items to your cart yet.</p>
            <Button
              as={Link}
              to="/products"
              size="lg"
              style={{
                backgroundColor: '#a5cb89',
                border: 'none',
                borderRadius: '25px',
                padding: '12px 40px'
              }}
            >
              Start Shopping
            </Button>
          </div>
        </Container>
      </div>
    );
  }

  return (
    <div className="py-5">
      <Container>
        <h1 className="fw-bold mb-4">Shopping Cart</h1>

        <Row>
          <Col lg={8} className="mb-4 mb-lg-0">
            <Card className="border-0 shadow-sm">
              <Card.Body className="p-4">
                <div className="d-none d-md-block">
                  <Table responsive borderless className="mb-0">
                    <thead className="border-bottom">
                      <tr>
                        <th className="pb-3">Product</th>
                        <th className="pb-3">Price</th>
                        <th className="pb-3">Quantity</th>
                        <th className="pb-3">Total</th>
                        <th className="pb-3"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {cartData.map((item) => (
                        <tr key={item.id} className="border-bottom">
                          <td className="py-3">
                            <div className="d-flex align-items-center">
                              <img
                                src={item.image}
                                alt={item.name}
                                style={{
                                  width: '80px',
                                  height: '80px',
                                  objectFit: 'cover',
                                  borderRadius: '8px'
                                }}
                                className="me-3"
                              />
                              <div>
                                <h6 className="mb-0">{item.name}</h6>
                              </div>
                            </div>
                          </td>
                          <td className="py-3 align-middle">
                            <span className="fw-bold">₹{item.price.toFixed(2)}</span>
                          </td>
                          <td className="py-3 align-middle">
                            <div className="d-flex align-items-center">
                              <Button
                                variant="outline-secondary"
                                size="sm"
                                onClick={() => updateQuantity(item, 'minus')}
                                style={{ borderRadius: '50%', width: '32px', height: '32px', padding: 0 }}
                              >
                                <Minus size={16} />
                              </Button>
                              <span className="mx-3 fw-bold">{item.quantity}</span>
                              <Button
                                variant="outline-secondary"
                                size="sm"
                                onClick={() => updateQuantity(item, 'plus')}
                                style={{ borderRadius: '50%', width: '32px', height: '32px', padding: 0 }}
                              >
                                <Plus size={16} />
                              </Button>
                            </div>
                          </td>
                          <td className="py-3 align-middle">
                            <span className="fw-bold">₹{(item.price * item.quantity).toFixed(2)}</span>
                          </td>
                          <td className="py-3 align-middle">
                            <Button
                              variant="link"
                              className="text-danger p-0"
                              onClick={() => removeItem(item.id)}
                            >
                              <Trash2 size={20} />
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>

                {/* Mobile View */}
                <div className="d-md-none">
                  {cartData.map((item) => (
                    <Card key={item.id} className="mb-3 border">
                      <Card.Body>
                        <div className="d-flex mb-3">
                          <img
                            src={item.image}
                            alt={item.name}
                            style={{
                              width: '80px',
                              height: '80px',
                              objectFit: 'cover',
                              borderRadius: '8px'
                            }}
                            className="me-3"
                          />
                          <div className="flex-grow-1">
                            <h6 className="mb-2">{item.name}</h6>
                            <p className="mb-0 fw-bold text-primary">₹{item.price.toFixed(2)}</p>
                          </div>
                          <Button
                            variant="link"
                            className="text-danger p-0"
                            onClick={() => removeItem(item.id)}
                          >
                            <Trash2 size={20} />
                          </Button>
                        </div>
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="d-flex align-items-center">
                            <Button
                              variant="outline-secondary"
                              size="sm"
                              onClick={() => updateQuantity(item.id, -1)}
                            >
                              <Minus size={14} />
                            </Button>
                            <span className="mx-3 fw-bold">{item.quantity}</span>
                            <Button
                              variant="outline-secondary"
                              size="sm"
                              onClick={() => updateQuantity(item.id, 1)}
                            >
                              <Plus size={14} />
                            </Button>
                          </div>
                          <span className="fw-bold">Total: ₹{(item.price * item.quantity).toFixed(2)}</span>
                        </div>
                      </Card.Body>
                    </Card>
                  ))}
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={4}>
            <Card className="border-0 shadow-sm">
              <Card.Body className="p-4">
                <h5 className="fw-bold mb-4">Order Summary</h5>

                <div className="d-flex justify-content-between mb-2">
                  <span className="text-muted">Subtotal</span>
                  <span className="fw-bold">₹{subtotal.toFixed(2)}</span>
                </div>
                <div className="d-flex justify-content-between mb-2">
                  <span className="text-muted">Shipping</span>
                  <span className="fw-bold">₹{shipping.toFixed(2)}</span>
                </div>
                <div className="d-flex justify-content-between mb-3">
                  <span className="text-muted">Tax (8%)</span>
                  <span className="fw-bold">₹{tax.toFixed(2)}</span>
                </div>

                <hr />

                <div className="d-flex justify-content-between mb-4">
                  <span className="fw-bold fs-5">Total</span>
                  <span className="fw-bold fs-5" style={{ color: '#a5cb89' }}>₹{total.toFixed(2)}</span>
                </div>

                <Button
                  size="lg"
                  className="w-100 mb-3"
                  style={{
                    backgroundColor: '#a5cb89',
                    border: 'none',
                    borderRadius: '8px'
                  }}
                >
                  Proceed to Checkout
                </Button>

                <Button
                  as={Link}
                  to="/products"
                  variant="outline-secondary"
                  size="lg"
                  className="w-100"
                  style={{ borderRadius: '8px' }}
                >
                  Continue Shopping
                </Button>

                <div className="mt-4 p-3 bg-light rounded">
                  <h6 className="fw-bold mb-2 small">Have a coupon?</h6>
                  <Form.Control
                    type="text"
                    placeholder="Enter coupon code"
                    className="mb-2"
                  />
                  <Button
                    variant="dark"
                    size="sm"
                    className="w-100"
                    style={{ borderRadius: '8px' }}
                  >
                    Apply Coupon
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Cart;
